import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";
import PageLoader from "../lib/page_loader";
import { debounce } from "lodash-es";

export default class extends Controller {
  static targets = [
    "onChange",
    "onChangeInstant",
    "onInput",
    "submitButton",

    // Deprecated targets
    "input",
    "inputInstant",
  ];
  static values = {
    targetId: String,
    actionUrl: String,
    responseKind: String,
  };

  abortController = null;
  submitEventTriggered = false;

  onInputChange = debounce(() => {
    this.submit();
  }, 250);

  onInputChangeInstant = () => {
    this.submit();
  };

  connect() {
    // Deprecated targets
    this.inputTargets.forEach((element) => {
      element.addEventListener("change", this.onInputChange);
    });
    this.inputInstantTargets.forEach((element) => {
      element.addEventListener("change", this.onInputChangeInstant);
    });
    this.element.addEventListener("submit", (event) => {
      this.submitEventTriggered = true;
    });
  }

  disconnect() {
    // Deprecated targets
    this.inputTargets.forEach((element) => {
      element.removeEventListener("change", this.onInputChange);
    });
    this.inputInstantTargets.forEach((element) => {
      element.removeEventListener("change", this.onInputChangeInstant);
    });
  }

  onChangeTargetConnected(element) {
    element.addEventListener("change", this.onInputChange);
  }

  onChangeInstantTargetConnected(element) {
    element.addEventListener("change", this.onInputChangeInstant);
  }

  onInputTargetConnected(element) {
    element.addEventListener("input", this.onInputChange);
  }

  onChangeTargetDisconnected(element) {
    element.removeEventListener("change", this.onInputChange);
  }

  onChangeInstantTargetDisconnected(element) {
    element.removeEventListener("change", this.onInputChangeInstant);
  }

  onInputTargetDisconnected(element) {
    element.removeEventListener("input", this.onInputChange);
  }

  async submit(formData = null) {
    if (this.abortController) {
      this.abortController.abort();
    }

    if (this.submitEventTriggered) {
      this.submitEventTriggered = false;
      return;
    }

    this.abortController = new AbortController();

    const responseKind =
      this.responseKindValue === "turbo-stream" ? "turbo-stream" : "html";

    try {
      const response = await get(this.actionUrlValue, {
        query: formData || new FormData(this.element),
        responseKind: responseKind,
        signal: this.abortController.signal,
      });

      if (responseKind !== "turbo-stream") {
        PageLoader.updateDOM(await response.html, `#${this.targetIdValue}`);
      }
    } catch (error) {
      if (error.name === "AbortError") {
        // Ignore aborted requests
        return;
      }

      // TODO: Handle error more gracefully
      console.error(error);
    }
  }
}
